<footer class="pt-2 text-light">
    <div class="container">
        <div class="row mx-2" style="font-size:.8em">
            <div class="col-2 text-center p-0 pointer" (click)="Home()">
                <div><i class="fas fa-home padding-small"
                        [ngClass]="{'fa-lg': globalService.selectedOption == 'HOME', 'padding-large': isIOS() == false }"></i>
                </div>
                <div class="text-center hide-small"
                    [ngClass]="{'optionClicked': globalService.selectedOption == 'HOME'}">{{
                    globalService.Get("HOME") }}</div>
            </div>
            <div class="col-3 text-center p-0 pointer" (click)="Calendar()">
                <div><i class="fas fa-calendar padding-small"
                        [ngClass]="{'fa-lg': globalService.selectedOption == 'CALENDAR', 'padding-large': isIOS() == false }"></i>
                </div>
                <div class="text-center hide-small"
                    [ngClass]="{'optionClicked': globalService.selectedOption == 'CALENDAR'}">{{
                    globalService.Get("CALENDAR") }}</div>
            </div>
            <div class="col-2 text-center p-0 pointer" (click)="Notification()">
                <div><i class="fas fa-bell padding-small"
                        [ngClass]="{'fa-lg': globalService.selectedOption == 'NOTIFICATIONS', 'padding-large': isIOS() == false }"></i>
                </div>
                <div class="text-center hide-small"
                    [ngClass]="{'optionClicked': globalService.selectedOption == 'NOTIFICATIONS'}">{{
                    globalService.Get("NOTICE") }}</div>
            </div>
            <div class="col-3 text-center p-0 pointer" (click)="CheckIn()">
                <div><i class="fas fa-clock padding-small"
                        [ngClass]="{'fa-lg': globalService.selectedOption == 'CHECKIN', 'padding-large': isIOS() == false }"></i>
                </div>
                <div class="text-center hide-small"
                    [ngClass]="{'optionClicked': globalService.selectedOption == 'CHECKIN'}">{{
                    globalService.Get("CHECKIN") }}</div>
            </div>
            <div class="col-2 text-center p-0 pointer" (click)="SystemMenu()">
                <div><i class="fas fa-list padding-small"
                        [ngClass]="{'fa-lg': globalService.selectedOption == 'SYSTEM_MENU', 'padding-large': isIOS() == false }"></i>
                </div>
                <div class="text-center hide-small"
                    [ngClass]="{'optionClicked': globalService.selectedOption == 'SYSTEM_MENU'}">{{
                    globalService.Get("SYSTEM") }}</div>
            </div>
        </div>
    </div>
</footer>